import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from 'ngx-bootstrap-modal';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonStorageKey } from '../../const/common-storage-key';
import { CommonConst } from '../../const/common-const';
import { N5041MainData } from '../../../n504/n5041-main-data';
import { GaUtil } from '../../utility/ga-util'
import { RedirectUtil } from '../../utility/redirect-util';
import { setTimeout } from 'timers';
import { FILE } from 'dns';
import { HeadMenuMainData } from './header-menu-data';
import { MessageUtil } from '../../utility/message-util';
import { DialogYesComponent } from '../dialog-yes';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.css']
})
export class HeaderMenuComponent extends DialogComponent<null, null> implements OnInit {

  // 処理結果
  public rtnCode: string;
  public mainData = new N5041MainData();

  // ヘルプ、活性、非活性
  public helpFlg: boolean = false;
  // headerInfoNameWidth
  public headerInfoNameWidth: number = 0;
  // ログアウトフラグ
  public logoutFlg: boolean = false;

  public headMenuMainData: HeadMenuMainData; // ST-413
  constructor(dialogService: DialogService,
    private http: HttpClient,
    private router: Router) {
    super(dialogService);
    this.headMenuMainData = new HeadMenuMainData();
  }

  ngOnInit() {
   
    this.headerInfoNameWidth = Number.parseFloat(sessionStorage.getItem('N5024HeaderInfoName'));
    // ヘルプの処理
    this.helpFile();
  }

  GetWidth(): string {
    return (this.headerInfoNameWidth + 68) + 'px';
  }

  GetMarginRight(): string {
    return (this.headerInfoNameWidth-700) + 'px';
  }

  /**
   * ヘルプの処理
   * */
  helpFile() {
    // ログインユーザのグループ区分
    this.mainData.gurupukubun = sessionStorage.getItem(CommonStorageKey.GURUPUKUBUN);
    // 画面ID
    this.mainData.gamenId = sessionStorage.getItem(CommonStorageKey.GAMENID);
    // ファイル名
    this.mainData.fileName = this.mainData.gurupukubun + this.mainData.gamenId + ".pdf";
    // フォルダ名
    // 強化テスト No-403 Start
    //this.mainData.folderName = sessionStorage.getItem(CommonStorageKey.YUZAID) + sessionStorage.getItem(CommonStorageKey.SESHONID);
    this.mainData.folderName = sessionStorage.getItem(CommonStorageKey.UNIQUEID) + sessionStorage.getItem(CommonStorageKey.SESHONID);
    // 強化テスト No-403 End
    // ログイン処理を行う
    this.mainData.uniqueId = sessionStorage.getItem(CommonStorageKey.UNIQUEID);
    this.http.post<N5041MainData>('/InitialN5041', this.mainData).subscribe((result => {
      // 非稼働の場合、メンテナンス画面に遷移する
      if (RedirectUtil.toMaintenance(result, this.router)) {
        return;
      }

      this.mainData = result[0];
      this.rtnCode = this.mainData.rtnCode;
      if (this.rtnCode === CommonConst.C_RTN_CODE_OK) {
        // ヘルプファイルが存在の場合
        if (this.mainData.existFile) {
          this.helpFlg = true;
        } else {
          this.helpFlg = false;
        }
      } else if (this.rtnCode === CommonConst.C_RTN_CODE_SYSTEM_ERR) {
        // システムエラー画面に遷移する。
        this.router.navigateByUrl('/ne01');
      }

    }), error => this.router.navigateByUrl('/ne01'));
  }

  headMenuClick(param) {
    if (param === 'user') {
      // ST-413 start
      this.headMenuMainData.pgmId = CommonConst.PGM_N4051;
      this.headMenuMainData.daikouFlg = sessionStorage.getItem(CommonStorageKey.DAIKOUFLG);
      this.http.post<HeadMenuMainData>('/KadouCheck', this.headMenuMainData).subscribe(result => {
        // 非稼働の場合、画面上部にエラーメッセージを表示する
        if (result[0].rtnCode == CommonConst.C_RTN_CODE_HIKADOU) {
          this.dialogService.addDialog(DialogYesComponent, { message: MessageUtil.getStorageMessage('N000023', ['ユーザ情報設定']) }
          ).subscribe((isOk) => { });
          return;
        }
        // それ以外のエラーは適切な共通エラー画面へ遷移する
        if (RedirectUtil.toMaintenance(result, this.router)) {
          return;
        }
        this.router.navigateByUrl('/n4051');
      }, error => this.router.navigateByUrl('/ne01', { skipLocationChange: true }));
      // ST-413 end
      
    } else if (param === 'help') {
      //// 処理結果.ファイルパス＋ "\" + ログインユーザーのグループ区分＋今開いているプログラムID．ｐｄｆを別タブで開く。
      //// ファイルパス
      //let fileName = this.mainData.filePath;
      //WindowUtil.windowUrlOpen(fileName);

      // ヘルプファイル削除
      this.deleteHelpFileAsync();
      
      // ヘルプ ヘルプ
      GaUtil.traceEvent_EachGroupCd('ヘルプ ヘルプ', '');
    } else if (param === 'logout') {
      // ログアウト時は非同期処理を呼び出さないように制御するため、ヘルプファイル有りとして削除処理を呼び出す。
      GaUtil.traceEvent_EachGroupCd('ログアウト ログアウト', '');      
      this.logoutFlg = true;
      //this.deleteFile();
      this.router.navigateByUrl('/n5011');

      sessionStorage.clear();
      this.http.get('/SessionClear').subscribe(result => { });
    }
    this.close(null);
  }

  async deleteHelpFileAsync() {
    await setTimeout(() => { this.deleteFile() }, 10000);
  }

  deleteFile() {

    if (!this.helpFlg && !this.logoutFlg) {
      return;
    }
    this.helpFlg = false;

    // ファイル削除処理
    this.http.post<N5041MainData>('/DeleteFileN5041', this.mainData).subscribe((result => {
      // 非稼働の場合、メンテナンス画面に遷移する
      if (RedirectUtil.toMaintenance(result, this.router)) {
        return;
      }

      this.mainData = result[0];
      this.rtnCode = this.mainData.rtnCode;
      if (this.rtnCode === CommonConst.C_RTN_CODE_OK) {

      } else if (this.rtnCode === CommonConst.C_RTN_CODE_SYSTEM_ERR) {
        // システムエラー画面に遷移する。
        this.router.navigateByUrl('/ne01', { skipLocationChange: true });
      }
      if (this.logoutFlg) {
        this.router.navigateByUrl('/n5011');
      }
    }), error => this.router.navigateByUrl('/ne01', { skipLocationChange: true }));

  }

  ngOnDestroy() {
    if (!this.logoutFlg) {
      // ヘルプファイル削除
      this.deleteHelpFileAsync();
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/header-menu/header-menu.component.ts